export default function hasSessionExpired(expires: string | number | Date | null = null): boolean {
  return !expires || new Date(expires).getTime() - Date.now() <= 0;
}
